import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { withLatestFrom, switchMap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';

import * as BrandsActions from './brands/brands.actions';
import * as BrandsSelectors from './brands/brands.selectors';
import * as CatalogActions from './catalog.actions';
import { CatalogPartialState } from './catalog.reducer';

@Injectable()
export class CatalogEffects {
  setApplianceType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CatalogActions.setApplianceType),
      withLatestFrom(
        this.store$.pipe(select(BrandsSelectors.getBrandsByApplianceState))
      ),
      switchMap(([action, brandsState]) => {
        if (!brandsState[action.code]) {
          return of(BrandsActions.loadBrands({ applianceCode: action.code }));
        } else {
          return EMPTY;
        }
      })
    )
  );

  constructor(
    private actions$: Actions,
    private store$: Store<CatalogPartialState>
  ) {}
}
